import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useSidebar } from '../../hooks/useSidebar';

const NAV_LINKS = [
  { label: 'Dashboard',  path: '/dashboard' },
  { label: 'Docs',       path: '/docs' },
  { label: 'Templates',  path: '/templates' },
  { label: 'Community',  path: '/community' },
];

const Navbar: React.FC = () => {
  const navigate  = useNavigate();
  const location  = useLocation();
  const { toggleSidebar } = useSidebar();

  return (
    <nav
      style={{
        position: 'fixed', top: 0, left: 0, right: 0,
        zIndex: 'var(--z-navbar)' as any,
        height: 'var(--nav-height)',
        background: 'rgba(248, 248, 248, 0.92)',
        backdropFilter: 'blur(20px)',
        borderBottom: '1px solid var(--border)',
        display: 'flex', alignItems: 'center',
        justifyContent: 'space-between',
        padding: '0 clamp(14px, 3vw, 24px)',
      }}
    >
      {/* Brand */}
      <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
        {/* Hamburger */}
        <button
          onClick={toggleSidebar}
          aria-label="Toggle sidebar"
          style={{
            display: 'none', flexDirection: 'column', gap: 4,
            padding: 6, background: 'transparent', border: 'none', cursor: 'pointer',
          }}
          className="hamburger-btn"
        >
          {[0,1,2].map((i) => (
            <span key={i} style={{ display:'block', width:20, height:2, background:'var(--text)', borderRadius:2 }} />
          ))}
        </button>

        <div
          style={{
            width: 32, height: 32, borderRadius: 8,
            background: 'linear-gradient(135deg, var(--accent), var(--accent2))',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            fontSize: 14, fontWeight: 700, color: '#000',
          }}
        >
          ⬡
        </div>

        <span
          style={{
            fontFamily: 'var(--font-sans)', fontWeight: 800, fontSize: '1.15rem',
            letterSpacing: '-0.5px',
            background: 'linear-gradient(90deg, var(--accent), var(--accent2))',
            WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent',
          }}
        >
          FIN Contra
        </span>
      </div>

      {/* Center nav pills */}
      <div
        style={{ display: 'flex', gap: 4 }}
        className="nav-center"
      >
        {NAV_LINKS.map(({ label, path }) => {
          const active = location.pathname.startsWith(path);
          return (
            <button
              key={label}
              onClick={() => navigate(path)}
              style={{
                padding: '6px 14px', borderRadius: 'var(--radius-full)',
                fontSize: '0.82rem', fontWeight: 600, cursor: 'pointer',
                border: 'none', fontFamily: 'var(--font-sans)',
                background: active ? 'var(--accent)' : 'transparent',
                color: active ? '#000' : 'var(--text-dim)',
                transition: 'all var(--transition-base)',
              }}
            >
              {label}
            </button>
          );
        })}
      </div>

      {/* Right actions */}
      <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
        <button
          style={{
            padding: '7px 14px', borderRadius: 'var(--radius-sm)',
            border: '1px solid var(--border)', background: 'var(--surface2)',
            color: 'var(--text-dim)', fontSize: '0.8rem', fontWeight: 600,
            cursor: 'pointer', fontFamily: 'var(--font-sans)',
            transition: 'all var(--transition-base)',
          }}
          className="nav-version-btn"
        >
          ⬡ v2.4
        </button>

        <button
          onClick={() => navigate('/apk')}
          style={{
            padding: '7px 16px', borderRadius: 'var(--radius-sm)',
            background: 'var(--accent)', color: '#000',
            border: '1px solid var(--accent)',
            fontSize: '0.8rem', fontWeight: 700,
            cursor: 'pointer', fontFamily: 'var(--font-sans)',
            transition: 'all var(--transition-base)',
          }}
        >
          ⬢ Build APK
        </button>
      </div>

      {/* Responsive styles */}
      <style>{`
        @media (max-width: 900px) {
          .nav-center { display: none !important; }
          .hamburger-btn { display: flex !important; }
        }
        @media (max-width: 540px) {
          .nav-version-btn { display: none !important; }
        }
      `}</style>
    </nav>
  );
};

export default Navbar;
